import { ActionTypes } from "./act_types";

export const openSidebar = () => ({
  type: ActionTypes.OPEN_SIDEBAR
})

export const closeSidebar = () => ({
  type: ActionTypes.CLOSE_SIDEBAR
})